import { h, Fragment } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";

import {
	Grid,
	Paper,
	Button,
	Box,
	Tooltip,
	Stepper,
	Step,
	StepLabel,
	Stack,

} from "@mui/material";

import { SessionContext } from "../../SessionContext";
import { AppContext } from "../../AppContext";

import PriceCard from "../Common/PriceCard";

import SellersCard from "../Common/SellersCard";
import BuyersCard from "../Common/BuyersCard";
import ProspectsCard from "../Common/ProspectsCard";
import AmbassadorCard from "../Common/AmbassadorCard";
import NotariesCard from "../Common/NotariesCard";
import DealMainInfos from "../Common/DealMainInfos";
import DealStatusCard from "../Common/DealStatusCard";
import ButtonWithTooltipAndBadge from "../Common/ButtonWithTooltipAndBadge";
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import ChangeDealName from "../Common/ChangeDealName";
import Dataroomcard from "../Common/Dataroomcard";
import PublicationCard from "../exports";
import { redThreadDealUser } from "../Common/redthread";

export default function DealDashboardV({ id, ...rest }) {
	const [state, setState] = useState({});
	const [session, setSession] = useContext(SessionContext);
	//console.log(rest)
	const app = useContext(AppContext);
	useEffect(() => {
		//console.log("session context", session, state)
		if (!state.actualDeal) { return }
		let topic = "room:ddv-" + state.actualDeal.uid
		if (session.socket && session[topic] === undefined) {

			let channel = session.socket.channel(topic, {})

			channel.on("new_msg",
				msg => {
					console.log("Got message", msg)
					switch (msg.t) {
						case "deal":

							setState((state) => ({
								...state,
								actualDeal: msg.p,
							}));
							break;

						default:

							break;
					}

				})

			channel.join()
				.receive("ok", ({ messages }) => {
					console.log("catching up", messages)
					setSession({ ...session, [topic]: channel })
				})
				.receive("error", ({ reason }) => console.log("failed join", reason))
				.receive("timeout", () => console.log("Networking issue. Still waiting..."))

		} else {
			//console.log("topic", topic, session.socket, state.actualDeal, session[topic] === undefined)
		}
	}, [session, state]);
	useEffect(() => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/0622fe92c03c4297ab3d5c00b0c56047/" + id, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":

						setState((state) => ({
							...state,
							actualDeal: res.pld,
						}));
						if (rest.matches && rest.matches.inv_ntr === "1") {
							app.refPopUp.current.handleChangeState(
								{
									opened: true,
									type: "010",
									uid: id,
									side: "VN"

								}
							)
						}
						break;
					case "err":
						break;
					default:
						break;
				}
			});

	}, []);
	const handleCancelMandate = () => {
		alert("popup")
	}

	if (state.actualDeal === undefined) {
		return;
	}
	useEffect(() => {
		redThreadDealUser(state, app);

	}, [state]);

	const steps = ["En constitution", "En vente", "Offre", "Promesse", "Acte authentique"];

	return (
		<div style="margin-top: 40px; ">

			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Paper style="padding: 5px">
						<Grid container alignItems="center">
							<Grid item xs={12} sm={6}>
								<Stepper
									activeStep={state.actualDeal.auth_signed ? 5 : state.actualDeal.iss ? 4 : state.actualDeal.off ? 3 : state.actualDeal.bid ? 2 : state.actualDeal.pub ? 1 : 0}
									alternativeLabel
								>
									{steps.map((label) => (
										<Step key={label}>
											<StepLabel>{label}</StepLabel>
										</Step>
									))}
								</Stepper>
							</Grid>
							<Grid item xs={12} sm={6}>
								{!state.actualDeal.closed_deal && <Box display="flex" alignItems="center" justifyContent="flex-end">
									{state.actualDeal.ip && state.actualDeal.mandate && (
										<Box p={1}>
											<Button variant="outlined" onClick={handleCancelMandate}>
												Résilier
											</Button>
										</Box>
									)}
									<Box>
										<Tooltip title="..." placement="bottom" arrow style="margin-left: 10px;">
											<Button variant="outlined" onClick={() => app.refPopUp.current.handleChangeState(
												{
													opened: true,
													type: "011",
													params: {
														ip: state.actualDeal.idp,
														uid: state.actualDeal.deal_uid,
														sellers: state.actualDeal.sellers.filter((s) => {
															return s.uid !== state.actualDeal.uid;
														}),
													}
												}
											)
											}>
												Quitter ce dossier de vente
											</Button>
										</Tooltip>
									</Box>
								</Box>}
							</Grid>
						</Grid>
					</Paper>
				</Grid>
				<Grid item xs={12}>
					<Grid container spacing={2}>
						<Grid item xs={12} md={4}>
							<Stack spacing={1}>
								<ChangeDealName actualDeal={state.actualDeal} />
								<PriceCard actualDeal={state.actualDeal} mode="V" />
								<DealMainInfos state={state} uid={id} mode="V" />
							</Stack>
						</Grid>
						<Grid item xs={12} md={4}>
							<Stack spacing={2}>

								{state.actualDeal.pub && !state.actualDeal.oabs && (
									<ProspectsCard actualDeal={state.actualDeal} />
								)}
								<AmbassadorCard actualDeal={state.actualDeal} />
								<SellersCard
									actualDeal={state.actualDeal}
									mode="VN"
									btn={state.actualDeal.idp && !state.actualDeal.mandate && <ButtonWithTooltipAndBadge
										tooltip={state.actualDeal.idp ? "Gérer les vendeurs" : "Gérer mes informations"}
										icon={state.actualDeal.idp ? <GroupAddIcon /> : <AccountBoxIcon />}
										onclick_cb={() => {
											window.location.href = state.actualDeal.idp ? (state.actualDeal.sellers.length == 1 ? "/du/" + state.actualDeal.sellers[0].uid + "?from=" + window.location.href : "/sellers/" + id) : "/du/" + actualDeal.uid + "?from=" + window.location.href;
										}}
										badge={false} />}
								/>
								{state.actualDeal.oabs && (
									<BuyersCard actualDeal={state.actualDeal} mode="VN" />
								)}
								{state.actualDeal && state.actualDeal.mandate && (
									<NotariesCard actualDeal={state.actualDeal} mode="VN" />
								)}
							</Stack>
						</Grid>
						<Grid item xs={12} md={4}>
							<Stack spacing={2}>
								<DealStatusCard state={state} uid={id} mode="V" />
								<PublicationCard uid={id} />
								<Dataroomcard id={id} stats={state.actualDeal.stats} flag={state.actualDeal.dataroom_flag} />
							</Stack>
						</Grid>
					</Grid>
				</Grid>
			</Grid >
		</div >
	);
}
